export enum ScheduleType {
  AMBULATORY = 'ambulatory',
  SURGICAL = 'surgical'
}
